import { render, staticRenderFns } from "./rectify_appointment_academic.vue?vue&type=template&id=2758f511"
import script from "./rectify_appointment_academic.vue?vue&type=script&lang=js"
export * from "./rectify_appointment_academic.vue?vue&type=script&lang=js"
import style0 from "./rectify_appointment_academic.vue?vue&type=style&index=0&id=2758f511&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports